module.exports = __webpack_public_path__ + "img/Fukka-FukaSeat2tone_CafeBrown.de2e136d.png";